import request from '@/utils/request'


// 查询联盟主体（推广者）列表
export function listUnionAlliance(query) {
  return request({
    url: '/union/union/alliance/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询联盟主体（推广者）分页
export function pageUnionAlliance(query) {
  return request({
    url: '/union/union/alliance/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询联盟主体（推广者）详细
export function getUnionAlliance(data) {
  return request({
    url: '/union/union/alliance/detail',
    method: 'get',
    params: data
  })
}

// 新增联盟主体（推广者）
export function addUnionAlliance(data) {
  return request({
    url: '/union/union/alliance/add',
    method: 'post',
    data: data
  })
}

// 修改联盟主体（推广者）
export function updateUnionAlliance(data) {
  return request({
    url: '/union/union/alliance/edit',
    method: 'post',
    data: data
  })
}

// 删除联盟主体（推广者）
export function delUnionAlliance(data) {
  return request({
    url: '/union/union/alliance/delete',
    method: 'post',
    data: data
  })
}
